import React, { useEffect, useState } from "react";
import {
  Link,
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import Sidebar from "../../../../partials/aside/Sidebar";
import TitleBar from "../../../../partials/content/TitleBar";
import helperSpinner from "../../../../../helpers/spinner";
import httpService from "../../../../../services/httpServices/httpServices";
import helpersNumber from "../../../../../helpers/numbers";
import helpersTime from "../../../../../helpers/time";

export default function Edit() {
  const history = useHistory();
  const params = useParams();
  const [noteCall, setNoteCall] = useState();
  const noteCallID = params.noteCallID;
  const userID = params.userID;

  useEffect(() => {
    getNoteCall();
  }, []);

  const sendForm = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestAddNoteCall = await sendRequestEditNoteCall(
      noteCallID,
      {
        title: document.querySelector("#title").value,
        text: document.querySelector("#text").value,
      }
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestAddNoteCall) {
      return;
    }
    history.push(`/user/manage/${userID}/note-call`);
  };

  const sendRequestEditNoteCall = async (noteCallID, dataForm) => {
    const headersRequest = getHeaderRequest();
    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/user/note-call/" + noteCallID,
        dataForm,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const generateForm = () => {
    return (
      <form
        onSubmit={(e) => {
          e.preventDefault();
          sendForm();
        }}
      >
        <div className="form-group">
          <label>عنوان</label>
          <input
            type="text"
            className="form-control"
            id="title"
            defaultValue={noteCall.unc_title}
            required
          />
        </div>
        <div className="form-group">
          <label>متن</label>
          <textarea
            className="form-control"
            id="text"
            defaultValue={noteCall.unc_text}
            rows="10"
            required
          ></textarea>
        </div>
        <button className="btn btn-success">ویرایش کردن</button>
      </form>
    );
  };

  const getNoteCall = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestAddNoteCall = await sendRequestGetNoteCall(
      noteCallID
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestAddNoteCall) {
      return;
    }
    setNoteCall(resultSendRequestAddNoteCall);
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetNoteCall = async (noteCallID) => {
    const headersRequest = getHeaderRequest();
    let result;
    try {
      result = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/user/note-call/" + noteCallID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return result.data.data;
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="ویرایش کردن یادادشت تماس با کاربر" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left">
                <Link
                  to={`/user/manage/${userID}/note-call`}
                  className="btn btn-primary"
                >
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i class="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              {noteCall && generateForm()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
